import dayjs from "dayjs";
import React from "react";
import {
  ChartComponentProps,
  ChartConfig,
  createChartConfig,
  PopularCoinData,
} from "src/components/Referral-partner/Analytics/analyticsTypes";
import PopularCoins from "src/components/Referral-partner/Analytics/charts/PopularCoinsList";
import { WarningWrapper } from "src/components/Referral-partner/Analytics/styles/shared.styles";
import api from "src/store/features/api";
import { useRPAnalyticsState } from "src/store/features/RPAnalytics.slice";

const useGetCoinsVisitedConfig = (): { coinsVisited: ChartConfig<PopularCoinData> } => {
  const { chartDateRange } = useRPAnalyticsState();

  // fetch data and states
  const {
    data: rawCoinsVisited,
    isLoading: visitsIsLoading,
    isFetching: visitsIsFetching,
    isError: visitsIsError,
    error: visitsError,
  } = api.useGetCoinVisitsQuery({
    timeFrame: chartDateRange.coinsVisited,
    timezone: dayjs.tz.guess(),
  });

  // format data
  const coinsVisitedData = React.useMemo((): PopularCoinData[] => {
    if (!rawCoinsVisited) return [];
    return rawCoinsVisited.data
      .map((coin): PopularCoinData => {
        return {
          name: coin.coinSymbol,
          code: coin.coinSymbol.split(" ")[0].toLowerCase(),
          visits: coin.visits,
        };
      })
      .sort((a, b) => b.visits - a.visits);
  }, [rawCoinsVisited]);

  // create chart config
  const coinsVisitedConfig = React.useMemo(
    (): { coinsVisited: ChartConfig<PopularCoinData> } => ({
      coinsVisited: createChartConfig<PopularCoinData>({
        title: "Popular Coins by Visits",
        type: "bar",
        menuMode: "compact",
        defaultDate: "all time",
        tooltip: "Cryptocurrencies Your Referrals View Most Often",
        isLoading: visitsIsLoading || visitsIsFetching,
        data: coinsVisitedData,
        component: ({ data }: ChartComponentProps<PopularCoinData>): JSX.Element => {
          if (visitsIsError) {
            return <WarningWrapper>{visitsError?.message}</WarningWrapper>;
          } else if (data.length <= 0) {
            return <WarningWrapper color="#002035">No Data</WarningWrapper>;
          } else {
            return <PopularCoins data={data} />;
          }
        },
      }),
    }),
    [coinsVisitedData, visitsIsLoading, visitsIsFetching, visitsIsError, visitsError],
  );

  return coinsVisitedConfig;
};

export default useGetCoinsVisitedConfig;
